import { render } from "./app-button.vue?vue&type=template&id=19c92cbc"
import script from "./app-button.vue?vue&type=script&lang=js"
export * from "./app-button.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19c92cbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19c92cbc', __exports__)) {
    console.log('reload')
    api.reload('19c92cbc', __exports__)
  }
  
  module.hot.accept("./app-button.vue?vue&type=template&id=19c92cbc", () => {
    console.log('re-render')
    api.rerender('19c92cbc', render)
  })

}


export default __exports__